import { IProjectApprovalRequest } from '../../../../models/projectApprovalRequest.model';
import { AppAction } from '../../../../state/app';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import {
  CLEAR_PENDING_APPROVAL_PROJECT_LIST,
  FETCH_PENDING_APPROVAL_PROJECT_LIST,
} from './pendingApprovalProjectList.actions';

export interface PendingApprovalProjectListState {
  loading: boolean;
  items: ReadonlyArray<IProjectApprovalRequest>;
  errorMessage: string;
  totalItems: number;
}

const initialState: PendingApprovalProjectListState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: PendingApprovalProjectListState = initialState,
  action: AppAction,
): PendingApprovalProjectListState => {
  switch (action.type) {
    case REQUEST(FETCH_PENDING_APPROVAL_PROJECT_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PENDING_APPROVAL_PROJECT_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PENDING_APPROVAL_PROJECT_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_PENDING_APPROVAL_PROJECT_LIST:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
